import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import * as uuid from 'uuid';
import { EntityLookupModel } from '@models/entity-lookup.model';
import { WallV2Model } from '@models/wall-v2.model';
import { FlattenWallsWorkerModel } from '@models/flatten-walls-worked.model';

@Injectable({
  providedIn: 'root',
})
export class FlattenWallsWorkerService {
  private worker: Worker | undefined;

  constructor() {
    if (typeof Worker !== 'undefined') {
      this.worker = new Worker(new URL('../../workers/flatten-walls.worker', import.meta.url));
    }
  }

  runFlattenWorker(walls: WallV2Model.WallMongoDocument[], lookup: EntityLookupModel.EntityLookupMap): Observable<FlattenWallsWorkerModel.RunWallsFlattenSuccessMessage> {
    if (!this.worker) {
      return new Observable((subscriber) => {
        subscriber.error('Web Workers not supported in this environment.');
      });
    }

    return new Observable((subscriber) => {
      const requestId = uuid.v4();

      const handleMessage = (evt: MessageEvent<FlattenWallsWorkerModel.FlattenWorkerMessage>) => {
        const msg = evt?.data;

        if (FlattenWallsWorkerModel.isRunWallsFlattenSuccessMessage(msg) && msg.requestId === requestId) {
          subscriber.next(msg);
          subscriber.complete();
        } else if (FlattenWallsWorkerModel.isRunWallsFlattenFailMessage(msg) && msg.requestId === requestId) {
          subscriber.error(msg.error);
        }
      };

      this.worker.addEventListener('message', handleMessage);

      const message: FlattenWallsWorkerModel.RunWallsFlattenMessage = {
        type: 'RUN_FLATTEN',
        requestId,
        walls,
        lookups: lookup,
      };

      this.worker.postMessage(message);

      // Cleanup listener on unsubscribe
      return () => {
        this.worker?.removeEventListener('message', handleMessage);
      };
    });
  }
}
